module.exports = __webpack_public_path__ + "static/media/jirou-kyouka-lose.fbb38db3.png";